<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <div class="logo-area">
        <div class="logo-circle doc-logo">
          <span class="logo-text">DOC</span>
        </div>
        <div class="company-info">
          <span class="company-name">{{ companyName }}</span>
        </div>
      </div>
    </div>

    <ul class="sidebar-menu">
      <li class="menu-item" :class="{ active: currentTab === 'docOverview' }">
        <button @click="$emit('navigate', 'docOverview')">
          <i class="fas fa-tachometer-alt"></i>
          <span>文档概览</span>
        </button>
      </li>

      <li class="menu-item" :class="{ active: currentTab === 'docLibrary' }">
        <button @click="$emit('navigate', 'docLibrary')">
          <i class="fas fa-book"></i>
          <span>文档库</span>
        </button>
      </li>

      <li class="menu-item has-submenu" :class="{ active: isDocManagementActive, open: docManagementOpen }">
        <button @click="toggleDocManagement">
          <i class="fas fa-cogs"></i>
          <span>文档管理</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="docManagementOpen">
          <li><button :class="{ active: currentTab === 'docAudit' }" @click="$emit('navigate', 'docAudit')">文档审批</button></li>
          <li><button :class="{ active: currentTab === 'docPermission' }" @click="$emit('navigate', 'docPermission')">文档权限</button></li>
        </ul>
      </li>

      <li class="menu-item" :class="{ active: currentTab === 'docSearch' }">
        <button @click="$emit('navigate', 'docSearch')">
          <i class="fas fa-search"></i>
          <span>全文检索</span>
        </button>
      </li>
    </ul>

    <div class="sidebar-toggle" @click="toggleSidebar">
      <i class="fas fa-chevron-left"></i>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  currentTab: { type: String, default: 'docOverview' }
})
defineEmits(['navigate'])

const companyName = ref('顾德智能')
const docManagementOpen = ref(false)

const isDocManagementActive = computed(() => ['docAudit', 'docPermission'].includes(props.currentTab))

const toggleDocManagement = () => {
  docManagementOpen.value = !docManagementOpen.value
}

const toggleSidebar = () => {
  const sidebar = document.querySelector('.sidebar')
  if (sidebar) sidebar.classList.toggle('collapsed')
  const wrapper = document.querySelector('#wrapper')
  if (wrapper) wrapper.classList.toggle('collapsed')
}
</script>

<style scoped>
.sidebar {
  width: 220px;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 60px;
  z-index: 1000;
  background: #2f4050;
  transition: width 0.3s ease;
  overflow-y: auto;
  overflow-x: visible;
}
.sidebar.collapsed { width: 50px; }
.sidebar-header {
  padding: 12px;
  background: #1f2d3d;
  display: flex;
  align-items: center;
}
.logo-area {
  display: flex;
  align-items: center;
  gap: 10px;
}
.logo-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
}
.doc-logo {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}
.logo-text {
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
.company-info { display: flex; flex-direction: column; }
.company-name { color: #fff; font-size: 14px; font-weight: 600; white-space: nowrap; }
.sidebar.collapsed .company-info { display: none; }

.sidebar-menu { list-style: none; margin: 0; padding: 10px 0; }
.menu-item { position: relative; }
.menu-item > button,
.submenu button {
  width: 100%;
  padding: 12px 20px;
  background: none;
  border: none;
  color: #a7b1c2;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  transition: all 0.2s;
  text-align: left;
}
.menu-item > button:hover,
.submenu button:hover { background: rgba(255,255,255,0.06); color: #fff; }
.menu-item.active > button { color: #fff; background: rgba(59,130,246,0.2); border-left: 3px solid #3b82f6; }
.menu-item > button i { width: 18px; text-align: center; font-size: 14px; }
.arrow { margin-left: auto; transition: transform 0.3s; font-size: 12px; }
.has-submenu.open > button .arrow { transform: rotate(180deg); }

.submenu { list-style: none; margin: 0; padding: 0; background: rgba(0,0,0,0.1); }
.submenu button { padding-left: 52px; font-size: 12px; }
.submenu button:hover { background: rgba(255,255,255,0.04); color: #fff; }
.submenu button.active { color: #60a5fa; background: rgba(59,130,246,0.12); border-left: 3px solid #60a5fa; }

.sidebar-toggle {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  padding: 10px;
  transition: color 0.2s;
}
.sidebar-toggle:hover { color: #fff; }
.sidebar-toggle i { font-size: 14px; }
</style>
